const resources = {
    scanRewardsCard: 'Scan Reward Cards in Store'
};

export default function getResource(label) {
    return resources[label];
}
